import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 30,
};

export const journalListTableControllerSlice = createSlice({
    name: 'journalListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = journalListTableControllerSlice.actions;

export default journalListTableControllerSlice.reducer;